import { useEffect, useState } from 'react';
import { fetchAvailableShippingChargesByOrder } from '../../util/apiUtils';

/**
 * A hook that fetches and returns the available shipping charges for an order.
 * New charges will be fetched any time the provided gearOrderId changes.
 *
 * @param {Number} gearOrderId The ID of the order for which to fetch available charges
 * @return {Object} availableShippingCharges A Map of name:price shipping charges
 * @return {boolean} loading A flag indicating if the fetch is in progress
 */
export default function useShippingMethod(gearOrderId) {
	const [availableShippingCharges, setAvailableShippingCharges] = useState(null);
	const [loading, setLoading] = useState(false);

	// Fetch the available shipping methods, convert the fetched list into a map, and set the map in state.
	useEffect(() => {
		if (gearOrderId) {
			setLoading(true);
			fetchAvailableShippingChargesByOrder(gearOrderId)
				.then((json) => {
					if (json && json.length) {
						// Convert the list of shipping charge items into a map with key={shippingMethod}, value={price}
						const chargeMap = json.reduce((map, charge) => {
							map[charge.shippingMethod] = charge.price;
							return map;
						}, {});

						setAvailableShippingCharges(chargeMap);
					} else {
						// Set to an empty object to remove the loading icon and show an error
						setAvailableShippingCharges({});
					}
				})
				.catch((e) => {
					// Set to an empty object to remove the loading icon and show an error
					setAvailableShippingCharges({});
				})
				.finally(() => setLoading(false));
		}
	}, [gearOrderId]);

	return [availableShippingCharges, loading];
}